// This file is auto-generated by "@aria-ui/cli". Do not edit this file directly.

import { registerDropIndicatorElement, type DropIndicatorElement, type DropIndicatorProps as DropIndicatorElementProps } from '@prosekit/web/drop-indicator';
import { createElement, forwardRef, useCallback, useRef, type ForwardedRef, type ForwardRefExoticComponent, type HTMLAttributes, type RefAttributes, useLayoutEffect } from 'react';

import { useEditorContext } from '../../contexts/editor-context.ts';

/** Props for the {@link DropIndicator} React component. */
export interface DropIndicatorProps {
  /**
   * The ProseKit editor instance.
   *
   * @default null
   * @hidden
   */
  editor?: DropIndicatorElementProps['editor'];
  /**
   * The line width in pixels.
   *
   * @default 2
   */
  width?: DropIndicatorElementProps['width'];
}

function DropIndicatorComponent(props: DropIndicatorProps, forwardedRef: ForwardedRef<DropIndicatorElement>) {
  registerDropIndicatorElement();

  const elementRef = useRef<DropIndicatorElement>(null);

  const p0Fallback = useEditorContext();

  const { editor: p0, width: p1, ...restProps } = props;

  useLayoutEffect(() => {
    const element = elementRef.current as Record<string, unknown> | null;
    if (!element) return;
    Object.assign(element, { editor: p0 ?? p0Fallback, width: p1 });
  });

  const mergedRef = useCallback(
    (element: DropIndicatorElement | null) => {
      elementRef.current = element;
      if (typeof forwardedRef === 'function') {
        forwardedRef(element);
      } else if (forwardedRef) {
        forwardedRef.current = element;
      }
    },
    [forwardedRef],
  );

  return createElement('prosekit-drop-indicator', { ...restProps, ref: mergedRef, suppressHydrationWarning: true });
}

/** A React component that renders an `prosekit-drop-indicator` custom element. */
export const DropIndicator: ForwardRefExoticComponent<DropIndicatorProps & HTMLAttributes<DropIndicatorElement> & RefAttributes<DropIndicatorElement>> = /* @__PURE__ */ forwardRef(DropIndicatorComponent);
